export default "__VITE_ASSET__0iYzaYUN__"